import React from 'react';
import {Divider, Modal, Steps} from "antd";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import uuidV4 from 'uuid/v4';
import GeneralInformation from "./GeneralInformation";
import CustomerInformation from "./CustomerInformation";
import {saveCallCenterAppointment} from "../../actions/createAppointmentActions";
import VinInformation from "./VinInformation";
import {
  getComment,
  getCustomerInformation,
  getGeneralInformation,
  getMobilityOption,
  getMobilitySolution,
  getReception,
  getSelectedDate,
  getServices,
  getStartTime,
  getTowing,
  getVin
} from "../../selectors/createAppointmentRequest";
import {isLoading} from "../../selectors/appointmentCreationModal";
import ServiceInformation from "./ServiceInformation";
import DateInformation from "./DateInformation";
import {DRIVE_IN_RECEPTION, FASTLANE_RECEPTION} from "../../public/journey1/definition/business";
import {getSelectedDealerId} from "../../selectors/customerDealer";
import Constants from "../../services/Constants";
import './AppointmentCreationModal.css';
import {validateEmail} from "./utils/function_helper";

const {Step} = Steps;

class AppointmentCreationModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      steps: [
        {step: 1, content: <VinInformation/>},
        {step: 2, content: <GeneralInformation/>},
        {step: 3, content: <ServiceInformation/>},
        {step: 4, content: <DateInformation/>},
        {step: 5, content: <CustomerInformation/>}
      ]
    };
  }

  prevStep = () => {
    const {current} = this.state;
    this.setState({current: current - 1});
  };

  nextStep = () => {
    const {current} = this.state;
    this.setState({current: current + 1});
  }

  onSave = () => {
    const {
      vin,
      comment,
      customer,
      generalInformation,
      mobility,
      mobilitySolution,
      dealerId,
      services,
      reception,
      selectedDate,
      startTime,
      towing
    } = this.props;
    this.props.dispatchSaveAppointment({
      body: {
        ...generalInformation,
        ...customer,
        services: {
          services: services.map(s => s.id),
          comment
        },
        mobility: {
          mobility,
          mobilitySolution,
          workspaceRequest: false
        },
        uuid: uuidV4(),
        reception: {
          dropOff: {
            driveIn: reception === DRIVE_IN_RECEPTION,
            duringWorkingHours: true,
            fastLane: reception === FASTLANE_RECEPTION,
            date: selectedDate,
            time: startTime,
          },
          towing
        }
      },
      params: {
        dealerId,
        vin
      }
    });
  }

  isNextIsDisabled = () => {
    const {current} = this.state;
    if (current === 0) {
      const {vin, dealerId} = this.props;
      return !vin || !vin.trim() === '' || vin.length !== 17 || !Constants.SUPPORTED_WMIS.includes(vin.slice(0, 3)) ||
        !dealerId;
    }
    if (current === 1) {
      const {generalInformation} = this.props;
      return !parseInt(generalInformation.mileage, 10) ||
        !generalInformation.licensePlate || generalInformation.licensePlate.trim() === '' ||
        !generalInformation.model || generalInformation.model.trim() === '';
    }
    if (current === 2) {
      const {comment, mobility} = this.props;
      return !comment || !comment.trim() === '' || !mobility
    }
    if (current === 3) {
      const {selectedDate} = this.props;
      return !selectedDate;
    }
    if (current === 4) {
      const {customer} = this.props;
      return !customer || !customer.firstname || !customer.firstname.trim() === '' ||
        !customer.lastname || !customer.lastname.trim() === '' ||
        !customer.language || !customer.language.trim() === '' ||
        !customer.phone || !customer.phone.trim() === '' ||
        !validateEmail(customer.login);
    }
  }

  render() {
    const {visible, loading} = this.props;
    const {current, steps} = this.state;

    return (
      <Modal className="call-center" title={<FormattedMessage id="section.appointment-creation.modal.title"/>}
             visible={visible} onCancel={this.props.onModalClose} width='100rem' maskClosable={false}
             footer={[
               <div className={current > 0 ? "d-flex justify-content-between" : ""}>
                 {current > 0 && (
                   <button type="default" className="btn btn-o-primary" style={{width: 'inherit'}}
                           onClick={this.prevStep}>
                     <FormattedMessage id="customer.journey.nav.previous"/>
                   </button>
                 )}
                 {current < steps.length - 1 && (
                   <button disabled={loading || this.isNextIsDisabled()} type="default" className="btn btn-primary"
                           style={{width: 'inherit'}}
                           onClick={this.nextStep}>
                     <FormattedMessage id="customer.journey.nav.next"/>
                   </button>
                 )}
                 {current === steps.length - 1 && (
                   <button disabled={this.isNextIsDisabled()} type="default" className="btn btn-primary"
                           style={{width: 'inherit'}}
                           onClick={this.onSave}>
                     <FormattedMessage id="action.save"/>
                   </button>
                 )}
               </div>
             ]}>
        <Steps progressDot current={current}>
          {steps.map((item) => (
            <Step key={item.title}
                  title={<FormattedMessage id={`appointment_creation_modal.step_${item.step}`}/>}
            />
          ))}
        </Steps>
        <Divider/>
        <div className="steps-content">
          {steps[current].content}
        </div>
      </Modal>
    );
  }
}


const mapStateToProps = state => ({
  comment: getComment(state),
  startTime: getStartTime(state),
  reception: getReception(state),
  selectedDate: getSelectedDate(state),
  services: getServices(state),
  dealerId: getSelectedDealerId(state),
  customer: getCustomerInformation(state),
  generalInformation: getGeneralInformation(state),
  loading: isLoading(state),
  towing: getTowing(state),
  vin: getVin(state),
  mobility: getMobilityOption(state),
  mobilitySolution: getMobilitySolution(state)
});

const mapDispatchToProps = dispatch => ({
  dispatchSaveAppointment: payload => dispatch(saveCallCenterAppointment(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentCreationModal);



// WEBPACK FOOTER //
// ./src/components/call-center/AppointmentCreationModal.js